<template>
    <div :id="'responsive_container-' + this.id">
        <slot></slot>
    </div>
</template>

<script>
const uniqueId = require('lodash.uniqueid')

export default {
    props: ["aspect_ratio"],
    data: () => ({
        id: ""
    }),
    beforeCreate() {
        this.id = uniqueId();
    }
}
</script>

<style lang="scss" scoped>
#responsive_container- {
  position: relative;
  padding-top: 56.25%;

  iframe {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border: 0;
    width: 100%;
    height: 100%;
  }
}
</style>